var pesos = Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
});
export default pesos;
